import React from 'react';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';
import { CurrencyUtils, SharedUtils, TranslationUtils } from '../../utils';
import { ReceiptLineSummary } from './ReceiptLineSummary';
import { OccupancyCounts, OccupancyKeys } from '../../types/occupancy';

interface ReceiptLinePetAdjustmentProps {
    preview: TripAdjustmentResponse;
    occupancy_details?: { initialOccupancy: OccupancyCounts | null; occupancyCounts: OccupancyCounts | null };
    locale: string;
}

export const ReceiptLinePetAdjustment: React.FC<ReceiptLinePetAdjustmentProps> = (props) => {
    const { preview, occupancy_details, locale } = props;
    const { delta } = preview;

    // @ts-ignore
    const { occupancyCounts, initialOccupancy } = occupancy_details;

    const change_request: { [key: string]: number } = {
        [OccupancyKeys.PETS]: (occupancyCounts?.pets.count as number) - (initialOccupancy?.pets.count as number),
    };

    const { pets } = change_request;
    const slugRemoved = TranslationUtils.get('payment_form_removed');
    const slugAdded = TranslationUtils.get('payment_form_added');

    return (
        <>
            <ReceiptLineSummary
                summaryTitle={`${SharedUtils.getSlugOccupancy('pets', pets < 0 ? pets * -1 : pets)} ${pets < 0 ? slugRemoved : slugAdded}`}
                summaryValue={CurrencyUtils.formatCurrency(delta.total, delta.currency)}
                currency={delta.currency}
                locale={locale}
            />
            <hr className={'detail-separator'} />
        </>
    );
};
